import React, { useEffect, useMemo, useState } from "react";
import "../Styles/Common.less";
import PropTypes from "prop-types";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, withRouter } from "react-router-dom";
import {
  MenuOutlined,
  PoweroffOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { logout } from "../Store/authStore";
import LocalStorage from "../Constants/LocalStorage";
import { Dropdown, Layout, Menu, message } from "antd";
import {
  AppEnvs,
  AppStorageKeys,
  DefaultBasePathMenu,
  DeviceManagePaths,
  NavMenuItems,
  UserMenuItems,
} from "../Constants/Constants";
import logo from "../../images/WordLogo/HomeSight_Logo_RGB_White.png";
import bellwhite from "../../images/bellwhite.png";
import { getCurrentUserFromStore } from "../Constants/Utilities";
import { Access, getUserFeatureList } from "./AccessControl/General";
import Notifications from "react-notifications-menu";
import { convertOrderList } from "../Helpers/OrderHelpers";
import { apiCallback } from "../ApiHandlers/Common";
import SessionStorage from "../Constants/SessionStorage";

const { Header, Content, Footer } = Layout;
/* Menus will appear in this order */
const MenuKeys = [
  "support", //0
  "device", //1
  "network", //2
  "order", //3
  "asset", //4
  "group", //5
  "trouble", //6
  "stats", //7
  "admin", //8
  "help", //9
  "tips", //10
  "about", //11
];

export const MainPage = (props) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const path = location.pathname?.slice(1)?.split("/") || [];
  const currentUser = useMemo(() => getCurrentUserFromStore(), []);
  const ENV_VARS = SessionStorage.get(AppStorageKeys.envVars);
  const BETA_PORTAL_URL = ENV_VARS.BETA_PORTAL_URL;
  const ALPHA_PORTAL_URL = ENV_VARS.ALPHA_PORTAL_URL;
  const portalRedirectPort=ENV_VARS.ALPHA_PORTAL_PORT || ENV_VARS.BETA_PORTAL_PORT;


  /** Access Control variables */
  const userFeatures = useMemo(() => getUserFeatureList(), [currentUser]);
  const allowUpdatePassword = userFeatures.includes(Access.user.updatePassword);
  const allowBetaRedirect =
   userFeatures.includes(Access.user.betaRedirect);
  const allowNotification = useMemo(() => {
    return userFeatures.includes(Access.user.notification);
  }, [userFeatures]);
  const allowNotificationNeworder = useMemo(() => {
    return userFeatures.includes(Access.user.notificationNeworder);
  }, [userFeatures]);

  const menuAccess = useMemo(() => {
    return {
      [MenuKeys[0]]: userFeatures.includes(Access.menu.support),
      [MenuKeys[1]]: userFeatures.includes(Access.menu.device),
      [MenuKeys[2]]: userFeatures.includes(Access.menu.network),
      [MenuKeys[3]]: userFeatures.includes(Access.menu.order),
      [MenuKeys[4]]: userFeatures.includes(Access.menu.asset),
      [MenuKeys[5]]: userFeatures.includes(Access.menu.group),
      [MenuKeys[6]]: userFeatures.includes(Access.menu.troubleshooting),
      [MenuKeys[7]]: userFeatures.includes(Access.menu.statistics),
      [MenuKeys[8]]: userFeatures.includes(Access.menu.adminSettings),
      [MenuKeys[9]]: userFeatures.includes(Access.menu.help),
      [MenuKeys[10]]: userFeatures.includes(Access.menu.tips),
    };
  }, [userFeatures]);

  const accessibleMenus = useMemo(
    () =>
      MenuKeys.reduce((accMenus, menu) => {
        if (
          !menuAccess.hasOwnProperty(menu) ||
          (menuAccess.hasOwnProperty(menu) && menuAccess[menu])
        ) {
          accMenus.push(menu);
        }
        return accMenus;
      }, []),
    [menuAccess]
  );

  const defaultMenu = useMemo(() => {
    if (path[0]) return path[0];
    const defaultMenuAccessible = accessibleMenus.some(
      (m) => NavMenuItems[m].key === DefaultBasePathMenu
    );
    if (defaultMenuAccessible) return DefaultBasePathMenu;
    const firstAccessibleMenu = accessibleMenus.find(
      (m) => !NavMenuItems[m].disabled
    );
    return NavMenuItems[firstAccessibleMenu].key;
  }, [accessibleMenus]);

  const [menuItem, setMenuItem] = useState(defaultMenu);
  const [notificationData, setNotificationData] = React.useState([]);
  const [annoucementData, setAnnouncementData] = React.useState([]);
  console.log("MainPage menu", menuItem, defaultMenu);

  useEffect(() => {
    allowNotificationNeworder && fetchOrderData();
    fetchConfig({});
  }, []);

  const fetchConfig = () => {
    const errorCallback = (error) => {
      console.log("Error in fetchConfig", error);
    };
    const successCallback = (data) => {
      setAnnouncementData(data?.config?.system_announcement);
    };
    try {
      const service = "HACLOUD",
        level = "global",
        identifier = "system";
      props.SCMApi.getConfigById(
        service,
        level,
        identifier,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  const fetchOrderData = () => {
    const errorCallback = (error) => {
      console.log("Error fetching New Order list!", error);
    };
    const successCallback = (data) => {
      const dataForNotifications = [];
      const ordersData = convertOrderList(data);
      const newOrders = ordersData
        ? ordersData.filter((o) => o.receivedStatus === "New")
        : [];
      let notificationLS = LocalStorage.get("notificationLS");
      const el = document.getElementById("notificationElement");
      dataForNotifications.push({
        message: `New Orders (${newOrders.length})`,
        detailPage: "/order/New",
      });
      setNotificationData(dataForNotifications);
      if (notificationLS === null) {
        notificationLS = { newOrdersCount: newOrders.length, markRead: false };
        el.querySelector(".count").style.display = "flex";
      } else if (notificationLS.newOrdersCount !== newOrders.length) {
        notificationLS = { newOrdersCount: newOrders.length, markRead: false };
        el.querySelector(".count").style.display = "flex";
      } else if (notificationLS.markRead) {
        el.querySelector(".count").style.display = "none";
      }
      LocalStorage.set("notificationLS", notificationLS);
    };
    try {
      const { history, orderApi } = props;
      orderApi.getOrderGroupsByProviderId(
        currentUser?.providerId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  const onMenuClick = (e) => {
    console.log("onMenuClick", e);
    const oldMenu = menuItem;
    setMenuItem(e.key);
    history.push("/" + e.key);
    /* Handle clicking active menu */
    if (oldMenu === e.key) {
      history.go();
    }
  };

  const notificationMarkRead = (data) => {
    let notificationLS = LocalStorage.get("notificationLS");
    notificationLS.markRead = true;
    LocalStorage.set("notificationLS", notificationLS);
    const el = document.getElementById("notificationElement");
    const nodeContainer = el.querySelector(".container");
    const nodeContainerItems = nodeContainer.querySelector(".items");
    nodeContainer.style.visibility = "visible";
    nodeContainer.style.opacity = 1;
    nodeContainer.style.pointerEvents = "all";
    nodeContainer.addEventListener("mouseleave", (e) => {
      setTimeout(() => {
        const nodeContainerAnnouncement =
          nodeContainer.querySelector(".annoucement");
        if (nodeContainerAnnouncement) {
          const nodeContainerAnnouncementDetail =
            nodeContainerAnnouncement.querySelector(".annoucement-detail");
          if (nodeContainerAnnouncementDetail) {
            nodeContainerAnnouncement.removeChild(
              nodeContainerAnnouncementDetail
            );
          }
        }
        nodeContainer.style.visibility = "hidden";
        nodeContainer.style.opacity = 0;
        nodeContainer.style.pointerEvents = "none";
      }, 1300);
    });

    const addAnnouncementDetail = (data) => {
      if (null === el.querySelector(".annoucement")) {
        addAnnouncement();
      } else {
        const elAnnouncement = el.querySelector(".annoucement");
        if (null === elAnnouncement.querySelector(".annoucement-detail")) {
          const node = document.createElement("div");
          node.className = "annoucement-detail";
          node.innerHTML += `<div>${data?.annoucementData?.brief}</div>`;
          node.innerHTML += `<div>${data?.annoucementData?.detail}</div>`;
          elAnnouncement.appendChild(node);
        } else if (elAnnouncement.querySelector(".annoucement-detail")) {
          const node = elAnnouncement.querySelector(".annoucement-detail");
          if (node) {
            elAnnouncement.removeChild(node);
          }
        }
      }
    };
    const addAnnouncement = (el, data) => {
      if (null === el.querySelector(".annoucement")) {
        const node = document.createElement("div");
        node.className = "card annoucement";
        const textnode = document.createTextNode(
          data?.annoucementData?.display_name
        );
        node.appendChild(textnode);
        nodeContainerItems.appendChild(node);
        nodeContainerItems
          .querySelector(".annoucement")
          .addEventListener("click", (e) => {
            addAnnouncementDetail(data);
          });
      }
    };
    if (
      data.annoucementData &&
      data.annoucementData?.brief &&
      typeof data.annoucementData === "object"
    ) {
      addAnnouncement(el, data);
    }
  };

  const onLogout = () => {
    dispatch(logout());
    history.push("/login");
  };

  const onPortalRedirect = () => {
    const currentUser = getCurrentUserFromStore();
    const { username, partner, providerId, access_token, providerType } =
      currentUser;
    const { protocol, hostname } = window.location;
    const portalRedirectUrl = ALPHA_PORTAL_URL || BETA_PORTAL_URL;
    const baseUrl = portalRedirectUrl || protocol + "//" + hostname;
    const betaProtalUrl = baseUrl + ":" + portalRedirectPort;
    const redirectUrl = `user=${username}&prov=${providerId}&part=${partner}&provtype=${providerType}}&env=${
      AppEnvs.HS
    }&tok=${encodeURIComponent(access_token)}`;
    return betaProtalUrl + "/login?" + redirectUrl;
  };

  const mainMenu = (
    <Menu onClick={onMenuClick} selectedKeys={[menuItem]}>
      {accessibleMenus.map((menu) => (
        <Menu.Item
          key={NavMenuItems[menu].key}
          disabled={NavMenuItems[menu].disabled}
        >
          <div className="menu-item-container">
            {NavMenuItems[menu].icon({ className: "menu-icon" })}
            <span className="menu-text">{NavMenuItems[menu].label}</span>
          </div>
        </Menu.Item>
      ))}
    </Menu>
  );

  const userMenu = (
    <Menu onClick={onMenuClick} selectedKeys={[menuItem]}>
      {allowUpdatePassword && (
        <Menu.Item key={UserMenuItems.updatePassword.key}>
          <div className="menu-item-container">
            {UserMenuItems.updatePassword.icon({ className: "menu-icon" })}
            <span className="menu-text">
              {UserMenuItems.updatePassword.label}
            </span>
          </div>
        </Menu.Item>
      )}
      {allowBetaRedirect && (
        <Menu.Item
          key={
            BETA_PORTAL_URL
              ? UserMenuItems.betaPortal.key
              : UserMenuItems.alphaPortal.key
          }
          onClick={onPortalRedirect}
        >
          <div className="menu-item-container">
            {UserMenuItems.betaPortal.icon({ className: "menu-icon" })}
            <a
              className="menu-text"
              style={{ color: "#0621b2" }}
              href={onPortalRedirect()}
            >
              {BETA_PORTAL_URL
                ? UserMenuItems.betaPortal.label
                : UserMenuItems.alphaPortal.label}
            </a>
          </div>
        </Menu.Item>
      )}
      <Menu.Item key={NavMenuItems.logout.key} onClick={onLogout}>
        <div className="menu-item-container">
          {NavMenuItems.logout.icon({ className: "menu-icon" })}
          <span className="menu-text">{NavMenuItems.logout.label}</span>
        </div>
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout className="main-page-container">
      <Header className="main-page-header">
        <div className="main-page-header-container">
          <div className="main-menu-container">
            <Dropdown overlay={mainMenu} overlayClassName="menu-dropdown">
              <div className="main-menu-icon">
                <MenuOutlined style={{ marginRight: "8px" }} />
              </div>
            </Dropdown>
            <div className="logo">
              <a
                className="full-logo"
                target="_blank"
                href="https://www.commscope.com/homesight/"
              >
                <img className="full-logo" alt="HomeSight" src={logo} />
              </a>
            </div>
            <span className="logo-tag-line">Partner Portal</span>
          </div>
          <div
            className="flex-row"
            style={{ color: "white", marginRight: "20px" }}
          >
            {allowNotification && (
              <div
                id="notificationElement"
                className="flex-align-center"
                style={{ marginRight: "5px" }}
                onMouseEnter={() => notificationMarkRead({ annoucementData })}
              >
                <Notifications
                  icon={bellwhite}
                  headerBackgroundColor="#0067b0"
                  height="86px"
                  width="300px"
                  data={notificationData}
                  header={{
                    title: "Notifications",
                    option: {},
                  }}
                />
              </div>
            )}

            <div className="flex-align-center" style={{ marginRight: "10px" }}>
              {currentUser?.partner}/{currentUser?.username}
            </div>
            <Dropdown
              placement="bottomCenter"
              overlayClassName="menu-dropdown user-menu-dropdown"
              overlay={userMenu}
            >
              <UserOutlined
                style={{ fontSize: "17px" }}
                className="flex-align-center"
              />
            </Dropdown>
          </div>
        </div>
      </Header>
      <Content>
        <Layout className="main-page-content-layout">
          <Content
            className={`main-page-content ${props.iframe ? "iframe-page" : ""}`}
          >
            {props.children}
          </Content>
        </Layout>
      </Content>
      <Footer className="main-page-footer">
        ©2021 HomeSight. All rights reserved.
      </Footer>
    </Layout>
  );
};

MainPage.propTypes = {
  iframe: PropTypes.bool,
  orderApi: PropTypes.object,
  SCMApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  orderApi: state.apis.orderApi,
  SCMApi: state.apis.SCMApi,
});

const connectedMainPage = connect(mapStateToProps)(MainPage);

export default withRouter(connectedMainPage);
